<template>
    <v-container fluid class="fill-height py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                :to="{
                    name: 'leads-inprogress',
                    params: { ruta: 'inProgress' },
                }"
            >
                NEW
            </v-tab>
            <v-tab
                :to="{
                    name: 'leads-onhold',
                    params: { ruta: 'onHold' },
                }"
            >
                ON HOLD
            </v-tab>
            <v-tab
                :to="{
                    name: 'leads-approved',
                    params: { ruta: 'approved' },
                }"
            >
                APPROVED
            </v-tab>
            <v-tab
                :to="{
                    name: 'leads-rejected',
                    params: { ruta: 'rejected' },
                }"
            >
                REJECTED
            </v-tab>
            <v-tab
                :to="{
                    name: 'leads-modifiedQuote',
                    params: { ruta: 'modified' },
                }"
            >
                MODIFICATION REQUESTED
            </v-tab>
        </v-tabs>
        <v-row>
            <v-col cols="12">
                <v-card :style="{ height: `${height}px` }" flat>
                    <router-view :key="$route.fullPath" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'Leading',
    data: () => ({
        loading: true,
        height: 0,
    }),
    async mounted() {
        try {
            this.loading = true
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = containerHeight - tabsHeight - 48
        },
    },
}
</script>

<style></style>
